exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".zG8LBj-uNIdoeSSo8avSb{width:34px!important}html[dir] .zG8LBj-uNIdoeSSo8avSb{margin-top:8px}html[dir=ltr] .zG8LBj-uNIdoeSSo8avSb{margin-right:7px}html[dir=rtl] .zG8LBj-uNIdoeSSo8avSb{margin-left:7px}html[dir] ._2qR7K66En7WWDOZUwvS7or{margin-bottom:17px;margin-top:9px}", ""]);
// Exports
exports.locals = {
	"quickComposeIcon": "zG8LBj-uNIdoeSSo8avSb",
	"composeAttendeeRow": "_2qR7K66En7WWDOZUwvS7or"
};